import React, { Component } from "react";
import PropTypes from "prop-types";
import ChatBot from "react-simple-chatbot";
import { ThemeProvider } from "styled-components";
import botAvatar from "../images/boticon.png"
var botMsg;

const theme = {
  background: "rgba(200,200,200,0.17)",
  fontFamily: "Helvetica",
  botFontSize: "20px",
  hideHeader: true,
  headerFontColor: "rgba(33, 180, 33, 0.67)",
  headerFontSize: "15px",
  // botBubbleColor: "#6d3dff",
  botBubbleColor: "#000",
  botFontColor: "#29be35",
  hideUserAvatar: true,
  userBubbleColor: "#0ea70e",
  userFontColor: "#fff"

};


const  { HostedModel }  =  require ( '@runwayml/hosted-models' ) ;

const  model  =  new  HostedModel ( { 
  url: "https://bot-talking-99c67050.hosted-models.runwayml.cloud/v1/",
  token: "D/5S78dw789dKpCl++3xMA==",
} ) ;

const prompt = 'Hey text generation model, finish my sentence';
model.query({ prompt }).then(result => console.log(result));

class MLProcess extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // loading: true,
      botMsg: ""
      // trigger: false,
    };
  }

  UNSAFE_componentWillMount() {
    const self = this;
    const { steps } = this.props;
    // const { input, output } = steps;
    // var humanMsg = steps.input.value;
    const inputs = {
      "prompt": steps.input.value,
      "max_characters": 180,
      "top_p": 0.9,
      // "seed": Math.round(Math.random()*600+200) 
      "seed": 562
    };
    console.log("input:" + steps.input.value);
    
    model.query(inputs).then(outputs => {
      const { generated_text, encountered_end } = outputs;
      var old = String(steps.input.value);
      var n = old.length;
      var nameN = String(generated_text);
      botMsg = String(nameN.substr(n+1));
      console.log("output:" + botMsg);

      this.setState({ botMsg });
    });

  }

  render() {
    const { botMsg } = this.state;
    console.log("send:" + botMsg);
    return (
      <div style={{ width: "100%" }}>
       <p>{botMsg}</p>
      </div>
    );
  }
}

MLProcess.propTypes = {
  steps: PropTypes.object
};

MLProcess.defaultProps = {
  steps: undefined
};

class Response extends Component {
  // UNSAFE_componentDidMount() {
  //   this.handleEnd = this.handleEnd.bind(this);
  // }

  // handleEnd({ step, values }) {
  //   // console.log(steps);
  //   // console.log(values);
  //   alert(`Chat handleEnd callback! Number: ${values[(0, 1, 2, 3)]}`);
  // }

  render() {
    return (
      <div>
        <ThemeProvider theme={theme}>
          <ChatBot
               headerTitle="Online"
               botFontSize="20px"
               placeholder="Type a message..."
               customDelay="1000"
               botAvatar={botAvatar}
              //  floating="true"
               width="100%"
               
              //  handleEnd={this.handleEnd}
            steps={[
              {
                id: "1",
                message: "Hi! I'm bot.",
                trigger: "input"
              },
              {
                id: "input",
                user: true,
                trigger: "output"
              },
              {
                id: "output",
                component: <MLProcess />,
                asMessage: true,
                trigger: "input"
              },
              // {
              //   id: "update",
              //   update: "input",
              //   trigger: "imbot"
              // }
            ]}
          />
        </ThemeProvider>
        <p>{JSON.stringify(this.states, null, 2)}</p>
      </div>
    );
  }
}

export default Response;
// export default ChatPage;
